import React, { useState } from "react";
import "../../css/ECA.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const ACTIVITIES = [
  { icon: "🏃", name: "Athletics" },
  { icon: "♟️", name: "Chess" },
  { icon: "⚽", name: "Football" },
  { icon: "🥋", name: "Karate" },
  { icon: "⛸️", name: "Skating" },
  { icon: "🏏", name: "Cricket" },
  { icon: "🏐", name: "Volleyball" },
  { icon: "🏓", name: "Pickleball" },
  { icon: "🏀", name: "Basketball" },
];

const FAQ_ITEMS = [
  {
    q: "What makes Sahara Public School's extracurricular program stand out?",
    a: "We offer a wide variety of activities that help students explore interests beyond academics, building confidence, teamwork, and creativity through sports, arts, and leadership opportunities.",
  },
  {
    q: "Why do parents look for schools with strong extracurricular activities?",
    a: "Extracurriculars help children grow holistically — improving communication, social skills, discipline, and creativity, which together shape a well-rounded personality.",
  },
  {
    q: "What kinds of extracurricular opportunities does Sahara Public School provide?",
    a: "Students can choose from sports, performing arts, clubs, competitions, and leadership activities, giving them the chance to discover new talents and enjoy a vibrant school life.",
  },
  {
    q: "How does Sahara Public School decide which activities to prioritise?",
    a: "We maintain a balanced mix of sports, arts, clubs and skill-building activities, led by qualified instructors, with regular opportunities to participate in events and competitions.",
  },
];

export default function ECA() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="eca-page">
      {}
      <SchoolHero
        title="Extra-Curricular Activities"
        subtitle="World-Class Infrastructure"
        image="/images/ff.jpeg"
      />
      <section className="eca-hero">
        <h1>Extra-Curricular Activities</h1>
        <p>
          Activities outside the classroom that support the physical and
          emotional development of every student.
        </p>
      </section>

      {}
      <section className="wrap eca-intro">
        <div>
          <h2>Growing Beyond the Classroom</h2>
          <p>
            Extra-curricular and co-curricular activities are a core part of
            holistic education at Sahara Public School. They help students build
            talent, social skills, critical thinking, and teamwork.
          </p>
          <p>
            Every student is encouraged to take part in at least one activity
            from each category, giving them a well-rounded school experience
            beyond textbooks and exams.
          </p>
          <p>
            To build a sense of belonging and healthy competition, many
            activities are organised through student Houses, encouraging
            teamwork, pride, and a spirit of friendly rivalry.
          </p>
        </div>
        <div className="eca-intro-img">
          <span className="emoji-badge">🏆</span>
        </div>
      </section>

      {}
      <div className="eca-houses">
        <p>
          Students are grouped into four Houses to encourage teamwork and
          healthy competition
        </p>
      </div>

      {}
      <section className="eca-grid-section">
        <div className="wrap">
          <h2>Choose Your Activity</h2>
          <p>
            Students can pick from a wide range of activities, with at least one
            required as part of their school experience.
          </p>
          <div className="eca-grid">
            {ACTIVITIES.map((a) => (
              <div className="eca-card" key={a.name}>
                <div className="eca-icon">{a.icon}</div>
                <div className="eca-name">{a.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap eca-note">
        <p>
          Students who show strong promise in a particular sport can be selected
          for our <strong>Gold Squad Programme</strong>, which offers
          additional, intensive training under skilled coaches.
        </p>
      </section>

      {}
      <section className="wrap eca-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
